function getPriceBreakdown(wranglerData) {
    if (!wranglerData?.price?.breakdown) {
        return {};
    }
    else {
        const result = {};
        for (const breakdown of wranglerData.price.breakdown) {
            const optionObj = result[breakdown.name] ?? (result[breakdown.name] = {});
            optionObj[breakdown.value] = {
                listPrice: breakdown.listPrice,
                discountPrice: breakdown.discountPrice,
                percentageOff: breakdown.percentageOff,
                amountSaved: breakdown.amountSaved,
            };
        }
        return result;
    }
}

export { getPriceBreakdown };
//# sourceMappingURL=getPriceBreakdown.mjs.map
